import axios from 'axios'
import { BASE_URL } from '../../constants/config'

async function createInstallation(fcmToken, scheme) {
    const options = {
        method: 'post',
        url: `${BASE_URL}/user/installation`,
        data: {
            fcmToken,
            scheme
        }
    }
    return axios(options)
}

async function updateInstallation(fcmToken, scheme, token) {
    const options = {
        method: 'put',
        headers: {
            'Authorization': `JWT ${token}`
        },
        url: `${BASE_URL}/user/installation`,
        data: {
            token: fcmToken,
            scheme
        }
    }
    return axios(options)
}

export default {
    createInstallation,
    updateInstallation
}